module.exports = new __parcel__URL__("neon_gold_mine_level_10.8b1af5ac.png").toString();